import styled from 'styled-components';
import { Card, Container, Row, Image, Spinner } from 'react-bootstrap';
import { CustomButton, CustomFormik, CustomInput } from 'components/CustomForm';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import InstituteLogo from 'assets/images/institute-logo.png';
import { useMutation } from 'react-query';
import { loginUser } from 'network/apis/LoginApi';
import { toast } from 'react-toastify';
import { useContext, useState } from 'react';
import { GlobalContext } from 'context/GlobalContext';
import { getMe } from 'network/apis/CommonApi';
import { getErrorMessage } from "helpers/strings";
import { device } from 'helpers/screen';
import { useNavigate } from 'react-router-dom';
import { ADMIN_USER, COMPANY_USER, PROVINCE_USER } from 'context/GlobalContext';
import CommonLogin from 'components/CommonLogin';
import { ForgotButton } from 'components/CommonWidgets';

const LoginPage = () => {
	const { authentication } = useContext(GlobalContext);
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();

	const handleLogin = async (rawData) => {
		const accessToken = rawData?.data?.data?.access_token;
		const refreshToken = rawData?.data?.data?.refresh_token;

		if (accessToken) {
			const userData = await getMe(accessToken);

			if (userData) {
				const userType = userData.user_type;

				authentication(accessToken, refreshToken, userData);
				switch (userType) {
					case ADMIN_USER:
						navigate('/admin/dashboard');
						break;
					case PROVINCE_USER:
						navigate('/province');
						break;
					case COMPANY_USER:
						navigate('/company');
						break;
					default:
						toast('این کاربر به پنل دسترسی ندارد', { type: 'error', position: 'bottom-right' });
				}
			} else {
				toast(`خطا در ورود، لطفا اتصال خود را بررسی کنید`, { type: 'error', position: 'bottom-right' });
			}
		} else {
			toast(`خطا در ورود، لطفا اتصال خود را بررسی کنید`, { type: 'error', position: 'bottom-right' });
		}
	};

	const loginMutation = useMutation(loginUser, {
		onSuccess: (data) => {
			handleLogin(data);
		},
		onError: (err) => {
			toast(
				getErrorMessage(err),
				{ type: 'error', position: 'bottom-right' }
			);
		},
		onSettled: () => {
			setLoading(false);
		},
	});

	return (
		<CommonLogin>
			<Formik
				initialValues={{ username: '', password: '' }}
				validate={(values) => {
					const errors = {};
					if (!values.username) {
						errors.username = 'ضروری';
					} else if (!values.password) {
						errors.password = 'پسورد معتبر نمی باشد';
					}
					return errors;
				}}
				onSubmit={(values, { resetForm }) => {
					setLoading(true);
					loginMutation.mutate(values);
					resetForm();
				}}
			>
				{({ isSubmitting }) => (
					<CustomFormik>
						<Field type="text" name="username">
							{({
								field,
								meta: { touched, error }
							}) => <CustomInput className={touched && error ? "invalid" : ""} {...field} placeholder='نام کاربری' />
							}
						</Field>
						<ErrorMessage name="username" component="div" />
						<Field type="password" name="password">
							{({
								field,
								meta: { touched, error }
							}) => <CustomInput className={touched && error ? "invalid" : ""} {...field} placeholder='رمز ورود' type='password' />
							}
						</Field>
						<ErrorMessage name="password" component="div" />
						<button type="submit" disabled={isSubmitting || loading} className='d-flex align-items-center justify-content-center'>
							{loading ? (
								<Spinner animation="border" role="status" size='sm' />
							) : (
								<span>ورود</span>
							)}
						</button>
					</CustomFormik>
				)}
			</Formik>
			<ForgotButton onClick={() => navigate('/forgot-password')}>فراموشی رمز ورود</ForgotButton>
		</CommonLogin>
	);
};

export default LoginPage;
